import { render, staticRenderFns } from "./emojiPicker.vue?vue&type=template&id=44f738b0&"
import script from "./emojiPicker.vue?vue&type=script&lang=ts&"
export * from "./emojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./emojiPicker.vue?vue&type=style&index=0&id=44f738b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports